module.exports = __webpack_public_path__ + "static/media/prediction_icon.53196a2a.svg";